var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCinturonSeguridad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 22.03,
    y1: 49.96,
    x2: 22.03,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,0C11.22,0,0,11.21,0,25s11.22,25,25,25,25-11.22,25-25S38.78,0,25,0ZM11.97,7.35l4.25,4.25-4.34,4.34-4.28-4.28c1.25-1.63,2.73-3.08,4.38-4.31ZM18.33,14.78c.28.28.73.28,1,0l.53-.53s0,0,0,0c.31-.31.82-.31,1.14,0l5.35,5.35c.31.31.31.82,0,1.14l-5.35,5.35c-.31.31-.82.31-1.14,0l-5.35-5.35c-.31-.31-.31-.82,0-1.14,0,0,0,0,0,0l2.67-2.67c.28-.28.28-.73,0-1s-.73-.28-1,0l-2.17,2.17-1.14-1.14,4.34-4.34,1.14,1.14-.03.03c-.28.28-.28.73,0,1ZM3.06,25c0-4.5,1.36-8.69,3.7-12.17l6.34,6.34c-.41.83-.27,1.87.42,2.56l5.35,5.35c.87.87,2.27.87,3.14,0l5.35-5.35c.87-.87.87-2.27,0-3.14l-5.35-5.35c-.69-.69-1.73-.83-2.56-.42l-6.28-6.28c3.42-2.2,7.48-3.48,11.84-3.48,12.1,0,21.94,9.84,21.94,21.94,0,4.36-1.28,8.42-3.48,11.84l-6.07-6.07c.41-.83.27-1.87-.42-2.56l-1.16-1.16c-.42-.42-.98-.65-1.57-.65h-2.27s-.02,0-.03-.01l-2.45-2.45c-.57-.57-1.5-.57-2.07,0l-3.21,3.21c-.57.57-.57,1.5,0,2.07l2.45,2.45s.01.02.01.03v2.27c0,.59.23,1.15.65,1.57l1.16,1.16c.69.69,1.73.83,2.56.42l6.14,6.14c-3.49,2.33-7.67,3.7-12.17,3.7-12.1,0-21.94-9.84-21.94-21.94ZM34.3,33.02c-.28-.28-.73-.28-1,0l-2.67,2.67s0,0,0,0c-.31.31-.82.31-1.14,0l-1.16-1.16c-.15-.15-.24-.35-.24-.57v-2.27c0-.3-.09-.59-.26-.83l3.31-3.31c.24.17.53.26.83.26h2.27c.22,0,.42.08.57.24l1.16,1.16c.31.31.31.82,0,1.14,0,0,0,0,0,0l-.53.53c-.28.28-.28.73,0,1,.28.28.73.28,1,0l.03-.03,1.14,1.14-4.34,4.34-1.14-1.14,2.17-2.17c.28-.28.28-.73,0-1ZM26.85,29.84l-1.64-1.64s-.02-.05,0-.07l3.21-3.21s.05-.02.07,0l1.64,1.64-3.27,3.27ZM38.34,42.41l-4.08-4.08,4.34-4.34,4.04,4.04c-1.22,1.65-2.68,3.13-4.31,4.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.93,23.86l3.21-3.21c.28-.28.28-.73,0-1-.28-.28-.73-.28-1,0l-3.21,3.21c-.28.28-.28.73,0,1,.28.28.73.28,1,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCinturonSeguridad);
export default __webpack_public_path__ + "static/media/Icon_CinturonSeguridad.d674341225bdd93524a16efed04e852a.svg";
export { ForwardRef as ReactComponent };